import React from 'react';
import Tooltip from './Tooltip';

export function formatBadgeCount(count: number): string {
  return count > 99 ? '99+' : String(count);
}

function getBadgeDimensions(display: string) {
  if (display === '99+') {
    return { size: 26, fontSize: 9 };
  }

  if (display.length >= 2) {
    return { size: 22, fontSize: 10 };
  }

  return { size: 18, fontSize: 10 };
}

interface CountBadgeProps {
  count: number;
  variant?: 'icon' | 'inline';
}

const CountBadge: React.FC<CountBadgeProps> = ({ count, variant = 'inline' }) => {
  if (count <= 0) return null;

  const display = formatBadgeCount(count);
  const isCapped = count > 99;
  const { size, fontSize } = getBadgeDimensions(display);

  const badge = (
    <span
      title={isCapped ? String(count) : undefined}
      style={{
        background: '#dc2626',
        color: '#fff',
        borderRadius: '50%',
        width: size,
        height: size,
        fontSize,
        fontWeight: 600,
        lineHeight: 1,
        flexShrink: 0,
        ...(variant === 'icon'
          ? {
              position: 'absolute',
              top: -8,
              right: -8,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }
          : {
              marginLeft: 8,
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
            }),
      }}
    >
      {display}
    </span>
  );

  if (isCapped && variant === 'inline') {
    return (
      <Tooltip text={String(count)} position="left">
        {badge}
      </Tooltip>
    );
  }

  return badge;
};

export default CountBadge;
